import { apiFetch } from './api'

/**
 * Fire-and-forget audit log for client-side mutations.
 * Calls POST /api/audit-event — never throws.
 */
export function logClientAudit(entry: {
  action: string
  entity_type: string
  entity_id?: string
  entity_name?: string
  details?: Record<string, unknown>
}) {
  apiFetch('/api/audit-event', {
    method: 'POST',
    body: JSON.stringify(entry),
  }).catch(() => {})
}
